import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Pricing() {
  const features = ['6 Tomos psicopedagógicos completos', '6 Bonos imprimibles (valor $90.000) GRATIS', 'Plantillas de informes y rúbricas', 'Material listo para imprimir', 'Fichas de seguimiento individual', 'Actualizaciones del MegaPack'];
  return <section id="pricing" className="py-24 bg-brand-50 relative" data-id="element-134">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-135">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-136">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-alert-light text-alert font-bold text-sm mb-6" data-id="element-137">
            <span className="w-2 h-2 rounded-full bg-alert animate-pulse" data-id="element-138"></span>
            Oferta por tiempo limitado · Quedan pocos cupos
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 tracking-tight" data-id="element-139">
            Accedé al MegaPack hoy mismo
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-4 border-brand-600 relative max-w-xl mx-auto" data-id="element-140">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-accent text-white font-black px-6 py-1.5 rounded-full text-sm uppercase tracking-wider shadow-md" data-id="element-141">
            Acceso completo
          </div>

          <div className="text-center mb-8 pt-2" data-id="element-142">
            <div className="text-brand-600 font-bold text-lg mb-2" data-id="element-143">
              MegaPack Psicopedagogía
            </div>
            <p className="text-brand-700 font-bold mb-6" data-id="element-144">
              6 Tomos + 6 Bonos GRATIS
            </p>

            <div className="mb-2" data-id="element-145">
              <span className="text-gray-400 line-through text-2xl font-medium" data-id="element-146">
                $64.990
              </span>
            </div>
            <div className="text-6xl font-black text-gray-900 mb-2" data-id="element-147">
              $19.990
            </div>
            <p className="text-sm text-gray-500" data-id="element-148">
              Pago único · Sin suscripción
            </p>
          </div>

          <div className="space-y-3 mb-8" data-id="element-149">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-3" data-id="element-150">
                <div className="bg-success-light p-1 rounded-full mt-0.5 shrink-0" data-id="element-151">
                  <Check className="w-4 h-4 text-success" data-id="element-152" />
                </div>
                <span className="text-gray-700" data-id="element-153">{feature}</span>
              </div>)}
          </div>

          <a href="https://www.iterapro.shop/checkouts/cn/hWNCW98WuUty6PfAlOIQm6dO/es-ar?_r=AQAB8Hm_Oqak93UE9-PB6mQDhB15kPWF2KmkC0TVQkCeFQY&cart_link_id=lHY87CRB&preview_theme_id=163813163097" target="_blank" rel="noopener noreferrer" className="block w-full text-center bg-brand-600 hover:bg-brand-700 text-white font-black py-5 px-6 rounded-xl transition-all transform hover:-translate-y-1 shadow-lg hover:shadow-brand-600/30 text-lg" data-id="element-154">
            QUIERO MI MEGAPACK
          </a>

          <p className="text-center text-xs text-gray-500 mt-4" data-id="element-155">
            🔒 Pago 100% seguro · Mercado Pago · Tarjeta · Transferencia
          </p>
        </motion.div>
      </div>
    </section>;
}